export default __webpack_public_path__ + "static/media/free-spins.abd2f751.svg";